/**
 * DealWizardModal — global host for the create-deal wizard.
 *
 * Replaces the retired NewDealModal. Every 'newDeal' trigger (command palette,
 * deals page, dashboard "new deal", the deal combobox) opens the SAME
 * DealWizardCard used inline in dashboard slot E — one question set across every
 * manual create surface. Chrome-light: the wizard owns its stepper and
 * Back/Next/Create nav, so the Modal supplies only the frame + close X.
 *
 * The Modal unmounts its children when closed, so the wizard remounts fresh on
 * every open — that is what re-seeds `prefill` (e.g. a name typed in the combobox)
 * per open.
 */
import { useNavigate } from 'react-router-dom';
import { Modal } from '../../../components/ui';
import { useUIStore } from '../../../stores/uiStore';
import { DealWizardCard } from './DealWizardCard';

export function DealWizardModal() {
    const navigate = useNavigate();
    const { activeModals, closeModal, getModalData } = useUIStore();

    const isOpen = activeModals.some(m => m.id === 'newDeal');
    // Combobox contract: `openModal('newDeal', { initialName })` seeds the name.
    const initialName = getModalData<{ initialName?: string }>('newDeal')?.initialName;

    return (
        <Modal isOpen={isOpen} onClose={() => closeModal('newDeal')} size="2xl" showCloseButton>
            <DealWizardCard
                variant="modal"
                prefill={initialName ? { dealName: initialName } : undefined}
                onCreated={deal => {
                    closeModal('newDeal');
                    navigate(`/deals/${deal.id}`);
                }}
            />
        </Modal>
    );
}
